
import { connect } from "react-redux";
import Header from './Header';
import {
    CssBaseline, Backdrop, CircularProgress, Typography
    , Container, Card, CardContent
} from '@mui/material';
import { withRouter } from "react-router-dom";
import SignIn from './SignIn';
import Copyright from '../core/Copyright';
import { makeStyles, createStyles } from '@mui/styles';

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      display: "flex"
    },
    footer: {
      padding: theme.spacing(1),
      marginTop: theme.spacing(3)
    },
    appBar: {
      transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
    toolbar: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      padding: theme.spacing(0, 1),
      marginBottom: theme.spacing(2),
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
    },
    content: {
      flexGrow: 1
    },
    cardMedia: {
      paddingTop: '56.25%', // 16:9
    },
    backdrop: {
      zIndex: `1000 !important`,
      color: '#fff',
    },
  }),
);

const Main = (props) => {
    const classes = useStyles();
    const children = props.children;
    const userInfo = JSON.parse(localStorage.getItem('user'));

    return (<>
        {!userInfo && <SignIn />}
        {userInfo && <div className={classes.root}>
            <Backdrop className={classes.backdrop} open={props.isLoading}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <CssBaseline />
            <Header />
            <main className={classes.content}>
                <div className={classes.toolbar} />
                {/* <Breadcrumbs aria-label="breadcrumb">
                    <Link color="inherit" href="/" className={classes.link}>
                        <HomeIcon className={classes.icon} /> Home
                        </Link>
                </Breadcrumbs> */}
                {children}
            </main>
            {userInfo && userInfo.user && userInfo.user.roleId !== 1 && <Container style={{ width: "400px" }}>
                <div className={classes.toolbar} />
                <Card variant="outlined">
                    <CardContent style={{ textAlign: "center" }}>
                        <form action="https://www.paypal.com/donate" method="post" target="_blank">
                            <input type="hidden" name="business" value="GBG2F3U9NKSPG" />
                            <input type="hidden" name="currency_code" value="SGD" />
                            <input type="image" src="https://www.paypalobjects.com/en_US/i/btn/btn_donateCC_LG.gif" border="0"
                                name="submit" title="PayPal - The safer, easier way to pay online!" alt="Donate with PayPal button" />
                            <img alt="" border="0" src="https://www.paypal.com/en_LK/i/scr/pixel.gif" width="1" height="1" />
                        </form>
                    </CardContent>
                </Card>
                <Card style={{ marginTop: "15px" }}>
                    <div className={classes.details}>
                        <CardContent className={classes.content}>
                            <Typography variant="h5" component="h2">
                                Address
                            </Typography>
                            <Typography variant="body2" component="p">
                                Blk 28 Sin Ming Lane
                                <br />
                                #05-135 Midview City, Singapore 573972
                            </Typography>
                            <Typography className={classes.pos} color="textSecondary">
                                Operating Hours
                            </Typography>
                            <Typography variant="body2" component="p">
                                Thursday/Friday 5.00 pm - 9.00 pm
                            </Typography>
                        </CardContent>
                    </div>
                </Card>
                <Card variant="outlined" style={{ marginTop: "15px" }}>
                    <CardContent>
                        <Typography className={classes.title} color="textSecondary" gutterBottom>
                            Your advertisement goes here...
                        </Typography>
                        {/* <Typography variant="h5" component="h2">
                            be - nev - o - lent
                        </Typography>
                        <Typography className={classes.pos} color="textSecondary">
                            adjective
                        </Typography>
                        <Typography variant="body2" component="p">
                            well meaning and kindly.
                            <br />
                            {'"a benevolent smile"'}
                        </Typography> */}
                    </CardContent>
                    {/* <CardActions>
                        <Button size="small">Learn More</Button>
                    </CardActions> */}
                </Card>
                {/* <Card style={{ marginTop: "15px" }}>
                    <CardActionArea>
                        <CardMedia
                            className={classes.cardMedia}
                            image="https://source.unsplash.com/random"
                            title="Image title"
                        />
                        <CardContent>
                            <Typography gutterBottom variant="h5" component="h2">
                                Lizard
                            </Typography>
                            <Typography variant="body2" color="textSecondary" component="p">
                                Lizards are a widespread group of squamate reptiles, with over 6,000 species, ranging
                                across all continents except Antarctica
                            </Typography>
                        </CardContent>
                    </CardActionArea>
                    <CardActions>
                        <Button size="small" color="primary">
                            Share
                        </Button>
                        <Button size="small" color="primary">
                            Learn More
                        </Button>
                    </CardActions>
                </Card> */}
            </Container>}
        </div>}

        {userInfo && <footer className={classes.footer}>
            <Copyright />
        </footer>}
    </>
    );
}

const mapStateToProps = state => ({
    isLoading: state.loading > 0
})

const mapActionToProps = {
}

export default withRouter(connect(mapStateToProps, mapActionToProps)(Main));